import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-packaging',
  standalone: true,
  templateUrl: '../../assets/packaging.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamPackagingIcon {}
